export const contactDetailsStyle = {
	wrapper: {
		marginBottom: '40px',
	},

	title: {
		marginBottom: '65px',
		textAlign: 'center',
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '40px',
	},

	details: {
		display: 'flex',
		gap: '12px',
		flexDirection: 'column',
	},

	info: {
		display: 'flex',
	},

	infoName: {
		maxWidth: '200px',
		width: '100%',
		color: 'var(--neutral-300)',
		textTransform: 'capitalize',
	},
};
